import { cn } from "@helpers/utils";
import { Globe } from "lucide-react";

type WebProductBadgeProps = {
    className?: string;
};

export default function WebProductBadge({ className }: WebProductBadgeProps) {
    return (
        <div
            className={cn(
                "inline-flex h-[24px] w-[24px] shrink-0 items-center justify-center rounded-md bg-[#D9DAFD] text-accent align-middle",
                className
            )}
        >
            <Globe size={12} className="shrink-0" />
        </div>
    );
}
